import { createRequest, RequestConfig } from 'app/common/api';

import { TUser } from '../core/user';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_user',
};

type NewUser = Omit<TUser, 'id'>;

export const addUserRequest = (body: NewUser) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
